<template>
  <div>
    Error {status}
  </div>
</template>

<script>
export default {
  name: 'Error',
}
</script>

<style>

</style>
